import { LoadingIcon as LoadingDs } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";

export const FormWrapper = styled.form`
  padding: 0px 32px 5px 32px;
  hr {
    background-color: var(
      --section-color-primary-100-background-color,
      var(--color-primary-100)
    );
  }
`;

export const ButtonContainer = styled.div`
  margin-bottom: 32px;
  padding-left: 28px;
  padding-top: 20px;
`;

export const CancelButton = styled(Button)`
  margin-left: 8px;
`;

export const Loading = styled(LoadingDs)`
  display: block;
  margin-top: 50px;
`;
